import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { EditMusicSourceDialogComponent } from "./edit-music-source-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    PipesModule,
    ReactiveFormsModule,
    OnsipFormsModule,
    ScrollingModule
  ],
  declarations: [EditMusicSourceDialogComponent],
  exports: [EditMusicSourceDialogComponent]
})
export class EditMusicSourceDialogModule {}
